module.exports = __webpack_public_path__ + "static/replaceME.413ac718.jpg";